import { Espece, EspeceCreateInput, EspeceListResponse, EspeceResponse, EspeceSelectInput, EspeceSelectOption, EspeceUpdateInput } from "@repo/types";
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export class EspeceService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.ESPECES.BASE, axios);
  }

  async getEspeces(filters: EspeceSelectInput): Promise<EspeceListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Espece>({ page, limit, ...rest });
  }

  async getEspeceById(id: number): Promise<EspeceResponse> {
    return this.get<EspeceResponse>(`/${id}`);
  }

  async createEspece(data: EspeceCreateInput): Promise<EspeceResponse> {
    return this.post<EspeceResponse, EspeceCreateInput>('', data);
  }

  async updateEspece(id: number, data: EspeceUpdateInput): Promise<EspeceResponse> {
    return this.put<EspeceResponse, EspeceUpdateInput>(`/${id}`, data);
  }

  async deleteEspece(id: number): Promise<EspeceResponse> {
    return this.delete<EspeceResponse>(`/${id}`);
  }

  async restoreEspece(id: number): Promise<EspeceResponse> {
    return this.put<EspeceResponse>(`/${id}/restore`);
  }

  async getEspeceOptions(): Promise<EspeceSelectOption[]> {
    return this.get<EspeceSelectOption[]>('/select');
  }

  async uploadEspeceImage(id: number, imageFile: File): Promise<EspeceResponse> {
    const formData = new FormData();
    formData.append('image', imageFile);
    
    const { data } = await this.axios.post<EspeceResponse>(
      `${ENDPOINTS.ESPECES.UPDATE_IMAGE(id.toString())}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    
    return data;
  }
}
